module.exports = __webpack_public_path__ + "img/employees1.7549f354.png";